import { OrderedMap } from 'immutable';
import * as checked from 'reporting-data/lib/checked';
import { getPropertyLabel, getReference } from 'reporting-data/v2/dataset/datasetRecords';
import { selectAndSortFieldValues } from 'reporting-visualizations/field/sort';
import { toVisualizationOrder } from '../../modify/sorts/report-sort-utils';
import { indexBy } from '../../../shared/lib/utils';
export const Bucket = checked.record({
  label: checked.string(),
  key: checked.string()
}, 'Bucket');
export const collectDimensionBuckets = (colorDimension, dataset) => {
  if (colorDimension === undefined) {
    return OrderedMap();
  }
  const alias = colorDimension.alias;
  const order = toVisualizationOrder(colorDimension, dataset);
  const references = selectAndSortFieldValues(dataset, alias, order).toOrderedSet().toOrderedMap().mapKeys((_, referenceId) => String(referenceId)).map(referenceId => getReference(dataset, alias, referenceId)).toOrderedMap();
  return references.map((reference, referenceId) => {
    if (reference == null) {
      return Bucket({
        key: referenceId,
        label: referenceId
      });
    }
    return Bucket({
      key: reference.id,
      label: reference.label
    });
  }).toOrderedMap();
};
export const collectMeasureBuckets = (measureColumns, dataset) => {
  return indexBy(measureColumns.toOrderedMap().map(column => {
    const alias = column.alias || column.get('alias');
    return Bucket({
      label: getPropertyLabel(dataset, alias),
      key: alias
    });
  }).toOrderedMap(), (_, bucket) => bucket.key);
};